
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { BiSearch } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";

const BlogInfo = () => {
  const {id} = useParams();
  const {blog,showDummyImage} = useAuth();
  const [details,setDetails] = useState([])
  useEffect(()=>{
    const selected = blog.find((item)=> parseInt(item.id)===parseInt(id));
    setDetails(selected)
  },[blog,id])
  return (
    <>
      <section className="blog-details">
        <div className="container">
          <div className="blog-details-wrapper">
            <div className="blog-details-left">
              {
                details?.detailsBlog?.map((detail,i)=><div key={i} className="blog-details-left-item">
                <div className="blog-details-img">
                  <img src={require(`../${process.env.REACT_APP_BLOG_IMAGE}${detail?.img}`)} alt="block-details-img" onError={({ currentTarget },imageSize = "815X470") => showDummyImage({ currentTarget }, imageSize)}/>
                </div>
                <div className="blog-details-content">
                  <div>
                    <div className="blog-details-date">
                      <span>{detail?.date}</span>
                    </div>
                  </div>
                  <div className="blog-details-meta">
                    <h3>{detail?.title}</h3>
                    <span>{detail?.options}</span>
                    <p>{detail?.blogText}</p>
                    <Link to="" className="continue">
                      CONTINUE READING ..
                    </Link>
                  </div>
                </div>
              </div>)
              }
            </div>
            <div className="blog-details-right">
              <form className="blog-details-from">
                <input type="search" placeholder="Search..." />
                <button type="button">
                  <BiSearch />
                </button>
              </form>
              <div className="blog-details-cate">
                <h4 className="blog-details-right-title">CATEGORIES</h4>
                <div className="blog-details-cate-links">
                  <Link to="" className="blog-details-cate-link">
                    Creative
                  </Link>
                  <Link to="" className="blog-details-cate-link">
                    Shopping
                  </Link>
                  <Link to="" className="blog-details-cate-link">
                    Videos
                  </Link>
                  <Link to="" className="blog-details-cate-link">
                    Uncategorized
                  </Link>
                  <Link to="" className="blog-details-cate-link">
                    Wordpress
                  </Link>
                </div>
              </div>
              <div className="blog-recent-posts">
                <h4 className="blog-details-right-title">RECENT POSTS</h4>
                <div className="blog-recent-post">
                  <Link to="" className="recent-post-name">
                    Tour of Envato’s Melbourne Head Quarters
                  </Link>
                  <span className="upload-date">December 28, 2016</span>
                </div>
                <div className="blog-recent-post">
                  <Link to="" className="recent-post-name">
                    Tour of Envato’s Melbourne Head Quarters
                  </Link>
                  <span className="upload-date">December 28, 2016</span>
                </div>
                <div className="blog-recent-post">
                  <Link to="" className="recent-post-name">
                    Tour of Envato’s Melbourne Head Quarters
                  </Link>
                  <span className="upload-date">December 28, 2016</span>
                </div>
              </div>
              <div className="blog-archives">
                <h4 className="blog-details-right-title">ARCHIVES</h4>
                <div className="blog-archives-items">
                  <Link to="" className="blog-archives-item">
                    November 2016
                  </Link>
                  <Link to="" className="blog-archives-item">
                    December 2016
                  </Link>
                  <Link to="" className="blog-archives-item">
                    January 2017
                  </Link>
                </div>
              </div>
              <div className="blog-tag">
                <h4 className="blog-details-right-title">TAGS</h4>
                <div className="blog-tag-items">
                  <Link to="" className="blog-tag-item">
                    Fashion
                  </Link>
                  <Link to="" className="blog-tag-item">
                    Electronic
                  </Link>
                  <Link to="" className="blog-tag-item">
                    Computer
                  </Link>
                  <Link to="" className="blog-tag-item">
                    Mobile
                  </Link>
                  <Link to="" className="blog-tag-item">
                    Make
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogInfo;
